import { useState } from 'react'
import { Form, Link, redirect, useNavigation } from 'react-router'
import LoginSVG from '#app/assets/svg/login'
import { GeneralErrorBoundary } from '#app/components/ErrorBoundary.tsx'
import { getUser } from '#app/utils/auth.server.ts'
import { type Route } from './+types/index'

export const loader = async ({ request }: Route.LoaderArgs) => {
	const user = await getUser(request)

	const carriers = user?.carriers || []

	if (carriers.length === 1) {
		return redirect(`/carriers/${carriers[0]}/reports`)
	}

	return {
		carriers,
		accessToken: user?.accessToken ?? '',
	}
}

export default function Index({ loaderData }: Route.ComponentProps) {
	const navigation = useNavigation()

	const [active, setActive] = useState<number | null>(null)

	return (
		<div className="flex grow flex-col">
			<main className="landing flex grow justify-center gap-8 overflow-y-auto overflow-x-hidden p-8 md:flex-row">
				<aside className="mb-8 flex h-min flex-col items-center gap-2 md:w-4/12 md:shrink-0">
					{loaderData.accessToken ? (
						<>
							{loaderData.carriers.map((carrier: string, index: number) => {
								const isActiveLoading =
									navigation.state === 'loading' && active === index

								return (
									<Link
										onClick={() => setActive(() => index)}
										key={carrier}
										to={`/carriers/${carrier}/reports`}
										className="btn btn-primary btn-lg btn-wide relative my-4 text-lg drop-shadow"
										aria-disabled={isActiveLoading}
									>
										<span
											className="transition-opacity"
											style={{ opacity: isActiveLoading ? 0.4 : 1 }}
										>
											{carrier} Reports
										</span>
										{isActiveLoading && (
											<span className="pointer-events-none absolute inset-0 flex items-center justify-center">
												<span className="loading loading-spinner" />
											</span>
										)}
									</Link>
								)
							})}
						</>
					) : (
						<>
							<h2>Login</h2>
							<Form method="post" action="/auth/login">
								<button className="btn btn-primary btn-lg btn-wide my-4 text-2xl drop-shadow">
									Log In
									<LoginSVG />
								</button>
							</Form>
							<div className="flex items-center">
								<h4 className="mr-2">Not a member?</h4>
								<button className="btn btn-neutral btn-sm text-white drop-shadow">
									Sign Up Now!
								</button>
							</div>
						</>
					)}
				</aside>
			</main>
		</div>
	)
}

export const ErrorBoundary = GeneralErrorBoundary
